
jQuery(document).ready(function($){

  var home = false;
	if($('body').hasClass('home')) {
		home = true;
  }
  



	if(home) {
		//Home Slides
		function slideshow(slidesSelector, delay) {
			var el = $(slidesSelector),
				delay = delay || 1500,
				current,
				index,
				total,
				next;

			setInterval(function() {
				current = el.siblings('.active'),
				index = current.index(),
				total = el.length - 1,
				next = index + 1;
				if(next > total) next = 0;
				current.removeClass('active');
				el.eq(next).addClass('active');
			}, delay );
		}
		slideshow('#hero .slide', 6000);
	}

	//Main Menu Open/Close
	var $wrap = $('#wrap'),
	$wrapAdjust = $('#wrap-adjust'),
	windowWidth;

	$('#menu-toggle,#close-menu').click(function(e){
		e.preventDefault();
		windowWidth = $(window).width();

		if(!$('body').hasClass('menu-open')) {
			if(windowWidth >= 1344) {
				var adjust = Math.round((windowWidth-1344)*.5);
				$wrapAdjust.css({'transform':'translateX('+adjust+'px)'});
			}
			$('body').addClass('menu-open');
		} else {
			$wrapAdjust.css({'transform':'translateX(0px)'});
			$('body').removeClass('menu-open');

		}


	});

	//Masthead scroll
	var rangeEnd = 150,
		scrollPosition,
		$masthead = $('#masthead'),
		$wrap = $('#wrap'),
		mhFlag = 0;

	$(window).scroll(function(e){ //Replace with requestanimationframe
		scrollPosition = $(window).scrollTop();
		if(scrollPosition > rangeEnd) {
			if(mhFlag == 0) {
				$masthead.addClass('scrolled');
				$wrap.addClass('scrolled');
			}
			mhFlag = 1;
		} else {
			$masthead.removeClass('scrolled');
			$wrap.removeClass('scrolled');
			mhFlag = 0;
		}
	});



	//Contact link click
	$('#menu-item-42 a').click(function(e){
		e.preventDefault();
		$('body').removeClass('menu-open');
		$wrapAdjust.css({'transform':'translateX(0px)'});
		$('html,body').animate({
			scrollTop : $('#foundation').offset().top+'px'
		}, 500);
	});

	//Product cat link
	$('#menu-item-50 > a').click(function(e){
		if(home) {
			e.preventDefault();
			$('html,body').animate({
				scrollTop : ($('#introduction').offset().top - 80)+'px'
			}, 500, function() {
					$('body').removeClass('menu-open');
					$wrapAdjust.css({'transform':'translateX(0px)'});
			});
		}
	});

	if(window.location.hash == '#introduction') {
		$('html,body').animate({
				scrollTop : ($('#introduction').offset().top - 80)+'px'
			}, 500);
	}



	$(window).load(function() {

		//History timeline positioning
		if($('body').hasClass('page-template-page-history-php')) {

			//1 year = 153px margin
			var height,
				topPos = [100,386,852,1006,1580,1970],
				offsets = [],
				totalHeight = 0,
				windowHeight = $(window).height();

			function positionTimelineEvents() {

				$('.timeline-event').each(function(i) {

					height = $(this).height();
					totalHeight = topPos[i] + height;

					$(this).css({'top': topPos[i]+'px'});
					offsets.push($(this).offset().top - windowHeight);

				});
				$('#timeline').height(totalHeight);
			}

			var $events = $('.timeline-event'),
				ticking = false,
				flag = 0,
				scrollPos,
				latestScrollPos;

			function onScroll() {
				scrollPos = window.pageYOffset || document.documentElement.scrollTop;
				requestTick();
			}
			function requestTick() {
				if(!ticking) {
					requestAnimationFrame(timelineFadein);
				}
				ticking = true;
			}
			function timelineFadein() {
				ticking = false;
				latestScrollPos = scrollPos;

				if(latestScrollPos >= offsets[1] && flag == 0) {
					$events.eq(1).addClass('inview');
					flag = 1;
				}
				if(latestScrollPos >= offsets[2] && flag == 1) {
					$events.eq(2).addClass('inview');
					flag = 2;
				}
				if(latestScrollPos >= offsets[3] && flag == 2) {
					$events.eq(3).addClass('inview');
					flag = 3
				}
				if(latestScrollPos >= offsets[4] && flag == 3) {
					$events.eq(4).addClass('inview');
					flag = 4;
				}
				if(latestScrollPos >= offsets[5] && flag == 4) {
					$events.eq(5).addClass('inview');
					flag = 5;
				}
			}




			if($(window).width() > 560) {
				positionTimelineEvents();
				window.addEventListener("scroll", onScroll, false);
			}

			var resizeFlag = 0;
			$(window).resize(function(){
				if($(window).width() > 560 && resizeFlag == 0) {
					positionTimelineEvents();
					window.addEventListener("scroll", onScroll, false);
					resizeFlag = 1;
				}
				if($(window).width() < 560) {
					resizeFlag = 0;
				}
			});

		}



	});



	//Placeholder Polyfill
	if(ie9 || ie8) {
		$('input[type=text], input[type=email], input[type=tel], textarea').each(function(index) {
				var ph = $(this).attr('placeholder');
				var val = $(this).val();
				if(val === '') {
					if(ph !== '') {
						$(this).val(ph);
					}
				}
		});
		$('input[type=text], input[type=email], input[type=tel], textarea').focus(function(e){
			var val = $(this).val();
			if(val === $(this).attr('placeholder')) {
				$(this).val('');
			}
		});
		$('input[type=text], input[type=email], input[type=tel], textarea').blur(function(e){
			if($(this).val() === '') {
				var ph = $(this).attr('placeholder');
				if(ph !== '') {
					$(this).val(ph);
				}
			}
		});

	}






	//Add to cart
	$('#addtocart').submit(function(e){
		e.preventDefault();

		var el = $(this),
			errors = 0;

		if(el.find('#product-color-option').val() === '') {
			errors++;
			el.find('.status').show();
			el.find('.status .success').hide();
			el.find('.status .error').show();
		}

		if(errors === 0) {

			$(this).find('input').removeClass('error');
			var product_data = $(this).serialize();

			$.ajax({
				type: "POST",
				url: theme_dir+'/functions/addto_cart.php',
				data: product_data,
				cache       : false,
				dataType    : 'json',
				error: function(xhr){
					console.log(xhr);
				},
				success: function(returnedData) {

					if(returnedData > 0) {

						$('.cart-link').addClass('active').find('span').text(returnedData);
						el.find('.status .error').hide();
						el.find('.status').show().find('.success').show();
					}
				}
			});

		}
	 });

	 //Update Cart
	 $('#edit-cart').click(function(e){
		$(this).addClass('hidden');
		$('#updatecart').addClass('active');
	 });


	$('#updatecart').submit(function(e){
		e.preventDefault();
		if($(this).hasClass('active')) {

			var product_data = $(this).serialize();

			$.ajax({
				type: "POST",
				url: theme_dir+'/functions/update_cart.php',
				data: product_data,
				cache       : false,
				dataType    : 'json',
				error: function(xhr){
					console.log(xhr);
				},
				success: function(returnedData) {
					//console.log(returnedData);
					if(typeof(returnedData) == 'object') {
						window.location.reload();
					}
				}
			});

		}
	});



	//Submit order
	$('#order-button').click(function(event){
		$('#order-form').submit();
	});

	$('#order-form').submit(function(e){
		e.preventDefault();
		var el = $(this),
			errors = 0;
		$(this).find('.required').each(function(i) {
			if($(this).val() ==  '' || $(this).val() == $(this).attr('placeholder')) {
				errors++;
				$(this).addClass('error');
			}
		});
		if(errors > 0) {
			el.find('.result').empty().addClass('error').append('Please complete all required fields.');
		}
		if(errors === 0) {
			el.find('input').removeClass('error');
			el.find('.result').removeClass('error').addClass('pending').empty().append('Please wait, your order is being processed...');

			var orderData = $(this).serialize();


			$.ajax({
				type: "POST",
				url: theme_dir+'/functions/order.php',
				data: orderData,
				error: function(xhr){
					console.log(xhr);
				},
				success: function(returnedData) {

					returnedData = jQuery.parseJSON(returnedData);
					//console.log(returnedData);
					if(returnedData.status == 'success') {
						if(returnedData.subscribe == true) {
							var mcData = jQuery.param({'EMAIL': returnedData.email});
							console.log(mcData);
							$.ajax({
								type: "POST",
								url: theme_dir+'/functions/mailchimp-subscribe.php',
								data: mcData,
								error: function(xhr) {
									console.log(xhr);
								},
								success: function(mcReturnedData) {
									window.location.href = confirmationURL;
								}
							});
						} else {
							window.location.href = confirmationURL;
						}
					}
					if(returnedData.status == 'error') {
						el.find('.result').empty().removeClass('pending').addClass('error').append('Please complete all required fields.');
					}

				}
			});

		}

	});




	 //Listen to whistle sound
	 var eventl = false;
	 function audioEnded() {
		$('#play-pause-product-sound').removeClass('pause');
	 }
	 $('#play-pause-product-sound').click(function(e){
		var audio = $('#product-sound');
		if(eventl == false) {
			audio[0].addEventListener('ended', audioEnded);
			eventl = true;
		}
		if($(this).hasClass('pause')) {
			audio[0].pause();
			$(this).removeClass('pause');
		} else {
			audio[0].play();
			$(this).addClass('pause');
		}
	 });



	 //jPlayer for IE8
	 if(ie8) {
		var audio = $('#product-sound');
		if(audio) {
			 var audioFile = $('#audio-source').data('audio');
			$("#jquery_jplayer_1").jPlayer({
				ready: function (event) {
					$(this).jPlayer("setMedia", {
						mp3: audioFile
					});
				},
				swfPath: theme_dir+"/js",
				supplied: "mp3",
				solution: "flash, html",
				oggSupport: false,
				nativeSupport: false,
				wmode: "window"
			});
		}
	}





	//SelectReplace, Christopher Eagle, Simple Square (simplesquare.com)

	//Fire her up
	function hasTouchEvents(){
		return typeof window.ontouchstart !== 'undefined';
	}
	//if(hasTouchEvents() == false && $(window).width() > 768 || hasTouchEvents() == true && $(window).width() > 768 ) {
		SelectReplace('.sr-replace');
	//}

	function SelectReplace(selector) {

		var el = $(selector);

		el.each(function(i){
			var select = $(this);
			select.wrap('<div class="select-replace-wrap"></div>');
			select.after('<div class="select-replace" id="sr-'+i+'"><dl><dt class="sr-toggle"><span class="chrome">&nbsp;</span></dt><dd><ul></ul></dd></dl></div>');
			select.find('option').each(function(i2){

				var option = $(this),
					dataValue = option.attr('value'),
					html = option.html();
				if(html.length == 0) html = false;

				//reset select elements to defaults
				option.prop('selected', function() {
					return this.defaultSelected;
				});

				if(option.attr('selected') && option.attr('disabled') && html)
				{
					$('#sr-'+i+' .sr-toggle').append(html).addClass('disabled');
					if(dataValue) {
						$('#sr-'+i+' ul').append('<li class="sr-disabled" data-value="'+dataValue+'">'+html+'</li>');
					} else {
						$('#sr-'+i+' ul').append('<li class="sr-disabled">'+html+'</li>');
					}
				}

				if(option.attr('selected') && !option.attr('disabled') && html)
				{
					$('#sr-'+i+' .sr-toggle').append(html);
					if(dataValue) {
						$('#sr-'+i+' ul').append('<li  data-value="'+dataValue+'" class="sr-selected sr-enabled">'+html+'</li>');
					} else {
						$('#sr-'+i+' ul').append('<li class="sr-selected sr-enabled">'+html+'</li>');
					}
				}

				if(option.attr('disabled') && !option.attr('selected') && html)
				{
					if(dataValue) {
						$('#sr-'+i+' ul').append('<li class="sr-disabled" data-value="'+dataValue+'">'+html+'</li>');
					} else {
						$('dl#sr-'+i+' ul').append('<li class="sr-disabled">'+html+'</li>');
					}
				}

				if(!option.attr('selected') && !option.attr('disabled') && html)
				{
					if(dataValue) {
						$('#sr-'+i+' ul').append('<li data-value="'+dataValue+'" class="sr-enabled">'+html+'</li>');
					} else {
						$('#sr-'+i+' ul').append('<li class="sr-enabled">'+html+'</li>');
					}
				}

				if(!html) {
					$('#sr-'+i+' ul').append('<li class="sr-disabled blank"></li>');
				}

			});
			select.hide();
		});

	}

	//selectReplace functionality
	function SelectReplaceOpenClose(el) {
		if(!el.hasClass('open')) {
			//Open
			el.addClass('open').after('<div class="sr-blanket">&nbsp;</div>');
		}
		else
		{
			//Close
			el.removeClass('open');
			$('.select-replace-wrap').removeClass('focus');
			$('.sr-blanket').remove();
		}
	}

	function SelectReplaceUpdate(el) {

		var parent = el.parents('.select-replace-wrap');

		if(!el.hasClass('sr-disabled')) {

			if(!el.hasClass('sr-selected')) {

				var selectedText = el.text(),
				selectedVal = el.data('value');

				//console.log(selectedVal);

				//Update replaced select for form submission
				parent.find('.sr-replace option').removeAttr('selected').siblings('option[value="'+selectedVal+'"]').prop('selected',true);
				parent.find('.sr-replace').change();
				//Update selectreplace and close
				el.addClass('sr-selected').siblings().removeClass('sr-selected');
				parent.find('.sr-toggle').removeClass('disabled').html(selectedText+'<span class="chrome">&nbsp;</span>');

				if(selectedVal.indexOf('http') > -1) {
					window.location.replace(selectedVal);
				}

			}
			parent.removeClass('focus');
			parent.find('.select-replace').removeClass('open error');
			parent.find('.sr-blanket').remove();
		}


	}

	//Open + Close + update
	$(document).on('click touchstart keydown', '.select-replace', function(e) {
		//console.log(e);
		var target = $(e.target);
		//console.log(target);

		//Open + Close on top el, mouse event
		if( target.is('dt.sr-toggle') ||  target.is('.chrome')) {
			if(e.type == 'click'  || e.type == 'touchstart') {
				e.preventDefault();
				SelectReplaceOpenClose($(this));
			}
		}


		//Update, mouse event
		if( target.is('li') ) {
			if(e.type == 'click' || e.type == 'touchstart') {
				e.preventDefault();
				SelectReplaceUpdate(target);
			}
		}
	});


	//Close due to click on document
	$(document).on('click touchstart', '.sr-blanket', function(e) {
		$('.select-replace-wrap').removeClass('focus');
		$('.select-replace').removeClass('open');
		$(this).remove();
	});
	$(document).on('focus', '.select-replace-wrap', function(e) {
		$('.select-replace-wrap').removeClass('focus');
		$(this).addClass('focus');
	});

  $('.product-colour-icon').each(function() {
    $(this).on('click', function() {
      $('.product-colour-icon').removeClass('product-colour-selected');
      $(this).addClass('product-colour-selected');
    });
  });


if($('body').hasClass('tax-product_cat')) {

  $('.product-colour-select').each(function() {
    if($(this).height() > 31) {
      $(this).closest('header').addClass('product-colour-select--lg');
    } 
    if($(this).height() > 80) {
      $(this).closest('header').removeClass('product-colour-select--lg').addClass('product-colour-select--vlg');
    } 
  });
  $('.product-colour-icon').each(function() {
    $(this).on('click', function(e) {
      e.preventDefault();

      $colorCodes = $(this).data('color-code').split(" ");
      $article = $(this).closest('article');
      $colorImg = $article.find('.hproduct-image-wrapper.'+$colorCodes[0]);

      $link = $(this).closest('a.url');
      $href = $link.attr('href').split('?');
      $link.attr('href', $href[0] + "?finish=" +$colorCodes[0]);

      if ($colorImg.length) {
        $article.find('.product-colour-icon').removeClass('product-colour-selected');
        $(this).addClass('product-colour-selected');
        $article.find('.hproduct-image-wrapper').hide();
        $colorImg.show();
      } else {
        $(this).closest('article').find('.product-colour-icon').removeClass('product-colour-selected');
        $(this).addClass('product-colour-selected');
        $article.find('.hproduct-image-wrapper').hide();
        $article.find('.hproduct-images--main').show();
      }
    });
  });
}

// Award switch to gold photo
if($('body').hasClass('term-award-and-presentation-whistles')) {

  $('.hproduct-images').each(function() {
    var mainImage = $(this).find('.hproduct-images--main');
    $(this).find('.hproduct-images--secondary').each(function() {
      if ($(this).hasClass('gold')) {
        $(this).show();
        mainImage.hide();
      }
    });

  });

}


if($('body').hasClass('single-product')) {

	// Variation change update the price
	$( ".single_variation_wrap" ).on( "show_variation", function ( event, variation ) {
		console.log('oha yayay');
		$new_price = $('.woocommerce-variation-price .price');

		if ($new_price.html() != '') {
			$('p.price').html($new_price.html());
		}

	} );

  $('#related-products .product-colour-select').each(function() {
    if($(this).height() > 31) {
      $(this).closest('header').addClass('product-colour-select--lg');
    }
    if($(this).height() > 80) {
      $(this).closest('header').removeClass('product-colour-select--lg').addClass('product-colour-select--vlg');
    } 
  });
  $('#related-products .product-colour-icon').each(function() {
    $(this).on('click', function(e) {
      e.preventDefault();

      $colorCodes = $(this).data('color-code').split(" ");
      $article = $(this).closest('article');
      $colorImg = $article.find('.hproduct-image-wrapper.'+$colorCodes[0]);

      $link = $(this).closest('a.url');
      $href = $link.attr('href').split('?');
      $link.attr('href', $href[0] + "?finish=" +$colorCodes[0]);

      if ($colorImg.length) {
        $article.find('.product-colour-icon').removeClass('product-colour-selected');
        $(this).addClass('product-colour-selected');
        $article.find('.hproduct-image-wrapper').hide();
        $colorImg.show();
      } else {
        $(this).closest('article').find('.product-colour-icon').removeClass('product-colour-selected');
        $(this).addClass('product-colour-selected');
        $article.find('.hproduct-image-wrapper').hide();
        $article.find('.hproduct-images--main').show();
      }
    });
  });
}



// Moving the product image to mobile position < 767
if($('body').hasClass('single-product')) {
  $mobileContainer = $('#product-image-mobile');
  $desktopContainer = $('#product-image');
  function moveProductImage() {
    if($(window).width() < 767) {
      if ( !$.trim( $mobileContainer.html() ).length) {
        $mobileContainer.html($desktopContainer.html());
        $desktopContainer.empty();
      }
    } else {
      if ( !$.trim( $desktopContainer.html() ).length) {
        $desktopContainer.html($mobileContainer.html());
        $mobileContainer.empty();
      }
    }
  }
  moveProductImage();

  $(window).resize(function() {
    moveProductImage();
  });
}






// Add to Cart Ajax

$(".single_add_to_cart_button").click(function(e) {

  e.preventDefault();

  $('.single-product--added-to-cart').text('');

  $thisbutton = $(this),
  $form = $thisbutton.closest('form.cart'),
  id = $thisbutton.val(),
  product_qty = $form.find('input[name=quantity]').val() || 1,
  product_id = $form.find('input[name=product_id]').val() || id,
  variation_id = $form.find('input[name=variation_id]').val() || 0;

  var data = {
    action: 'woocommerce_ajax_add_to_cart',
    product_id: product_id,
    product_sku: '',
    quantity: product_qty,
    variation_id: variation_id,
  }; 

  $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

  $.ajax({
          type: 'post',
          url: wc_add_to_cart_params.ajax_url,
          data: data,
          beforeSend: function (response) {
              $thisbutton.removeClass('added').addClass('loading');
          },
          complete: function (response) {
              $thisbutton.addClass('added').removeClass('loading');
          },
          success: function (response) {

              if (response.error & response.product_url) {
                  window.location = response.product_url;
                  $('.single-product--added-to-cart').text(response.error).addClass('error');
                  return;
              } else {
                var currentCartCount = $('.cart-link span').html();
                var newCartCount = parseInt($('.cart-link span').html()) + parseInt($('.input-text.qty').val());
                $('.cart-link span').html(newCartCount);
                $('.cart-link').addClass('active');
                //$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                $('.single-product--added-to-cart').html('Your cart has been updated.');
              }
          },
      });



  console.log('clicked');	
  

});

  // $( document ).on( 'change', 'input.qty', function() {
  //   console.log( 'qty change');
  // });

	//Product image sizing to content
	if($('body').hasClass('single-product')) {

		function alignProductImageOnLoad() {
			if($(window).width() > 1344) {
				var $product = $('#product'),
					$productImage = $('.product-image');

				//if($product.height() > 680 && $product.height() < 1000) {
					//$productImage.height($product.height());
					var margin = Math.round((1000 - $product.height()) *.5);
					$productImage.find('img').css({'margin-top': '-'+margin+'px'});
				//}
				//if($product.height() > 1000) {
					//$productImage.find('img').css({'position':'relative'});
				//}
			}
		}
		alignProductImageOnLoad();

		$(window).resize(function(e){
			alignProductImageOnLoad();
		});

		// Color Selector
		//
		function toTitleCase(str) {
			return str.replace(/\w\S*/g, function(txt){
					return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		}

		$('.product-colour-icon').each(function() {
			$(this).on('click', function() {

				//console.log('clicked swatch');
				$('.product-colour-icon').removeClass('product-colour-selected');
				$(this).addClass('product-colour-selected');
				$('#product-color-option').val($(this).data('color-code').toUpperCase());

				// Change select 
				// finish or colour?
				if ($('#finish').length) {
					//console.log('finish');
					$('#finish').val( $(this).data('color-code').toUpperCase() ).change();
				} else {
					//console.log(toTitleCase($(this).data('color-code')));
					$('#colour').val( toTitleCase($(this).data('color-code')) ).change();
				}           

				$('#product-colour-name').text(toTitleCase($(this).data('color-code')));

				$colorCodes = $(this).data('color-code').split(" ");

			});
		});

	}
  
  

  // Home
  
  $('.video-iframe').fitVids();

	// Youtube videos
	if ($('.home-video').length) {
		// If there's a video overlay setup youtube api
		var tag = document.createElement('script');
		tag.id = 'yt-iframe-api';
		tag.src = 'https://www.youtube.com/iframe_api';
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		function onPlayerStateChange(event) {
			if (event.data == YT.PlayerState.ENDED) {
				$('#playVideo').removeClass('playing');
			}
		}

    window.onYouTubeIframeAPIReady = function () {
      var player;
      player = new YT.Player('ytplayer', {
				events: {
					'onStateChange': onPlayerStateChange
				}
			});
      
      $('#playVideo').on('click', function() {
        $(this).addClass('playing');
        player.playVideo();
      });
    }
  }

  // 
  
  $('.product-remove a').each(function() {
    console.log('each');
    
    $(this).hover(function () {
      $(this).closest('tr').trigger('hover');
      console.log('over');
    },
    function() {
      
    });
  });

  // $('.product-remove a').click(function ()  {
  //   var data = {
  //     'action': 'cart_count_retriever'
  //   };
  //   jQuery.post(ajax_object.ajax_url, data, function(response) {
  //     $('.cart-link span').html(response);
      
  //   });
  // });

  $( document.body ).on( 'updated_cart_totals', function(){
    var data = {
      'action': 'cart_count_retriever'
    };
    jQuery.post(ajax_object.ajax_url, data, function(response) {
      $('.cart-link span').html(response);
      
    });
  });

  $( document.body ).on( 'item_remove_clicked', function(){
    var data = {
      'action': 'cart_count_retriever'
    };
    jQuery.post(ajax_object.ajax_url, data, function(response) {
      $('.cart-link span').html(response);
      
    });
  });

  


  




});
